<template>
  <div
    class="d-flex justify-content-center"
    v-if="showNotification">
    <span
      class="d-flex align-items-center text-secondary"
      style="font-size: 0.95rem;">
      <span
        v-if="currentIconSvg"
        class="banner-footer-icon mr-1"
        :style="{ color: iconColor, '--icon-color': iconColor || undefined }"
        v-html="currentIconSvg"
      />
      <span v-html="text"></span>
      <a
        v-if="buttonText"
        :href="buttonLink"
        :title="buttonTitlePlain"
        target="_blank"
        rel="noopener"
        class="text-primary font-weight-bold text-underline custom-footer-link ml-1"
        @click="sendLog"
      >{{ buttonText }}</a>
    </span>
  </div>
</template>

<script>
import bannerNotificationService from '@/services/banner-notification'
import { bannerIconPathmap, defaultBannerIconName } from '@/assets/icons/banner-icons'

const packageConfig = require('../../package.json')

export default {
  name: 'BannerFooter',
  data () {
    return {
      showNotification: false,
      datadogLogsFooter: null,
      messageLog: null,
      text: null,
      buttonText: null,
      buttonLink: null,
      buttonTitle: null,
      iconColor: null,
      iconName: null
    }
  },
  computed: {
    currentIconSvg () {
      if (!this.iconName) return null
      const exact = bannerIconPathmap[this.iconName]
      if (exact) return exact
      const lower = this.iconName.toLowerCase()
      const key = Object.keys(bannerIconPathmap).find(k => k.toLowerCase() === lower)
      return bannerIconPathmap[key] || null
    },
    /** Texto puro para o tooltip (title não suporta HTML) */
    buttonTitlePlain () {
      if (!this.buttonTitle) return ''
      const div = document.createElement('div')
      div.innerHTML = this.buttonTitle
      return (div.textContent || div.innerText || '').trim()
    }
  },
  methods: {
    async getActiveBannerNotification () {
      const result = await bannerNotificationService.getActiveNotification()

      if (result.success) {
        const { data } = result
        this.messageLog = data.messageLog
        this.text = data.text
        this.buttonText = data.buttonText
        this.buttonLink = data.utmPortal ? `${data.buttonLink}${data.utmPortal}` : data.buttonLink
        this.buttonTitle = data.buttonTitle
        this.iconColor = data.iconColor
        this.iconName = data.iconName
        this.showNotification = true
      } else {
        this.showNotification = false
      }
    },
    sendLog () {
      if (this.datadogLogsFooter && this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.user) {
        this.datadogLogsFooter.info(this.messageLog, {
          email: this.$store.state.auth.user.email,
          domain: this.$store.state.auth.organization.domain,
          role: this.$store.state.auth.user.role
        })
      }
    }
  },
  beforeMount () {
    if (window.DD_LOGS) {
      if (window.DD_LOGS_INITIALIZED) return
      window.DD_LOGS.init({
        clientToken: process.env.DATADOG_CLIENT_TOKEN,
        site: process.env.DATADOG_SITE,
        service: process.env.DATADOG_SERVICE,
        env: process.env.NODE_ENV,
        version: packageConfig.version,
        forwardErrorsToLogs: false,
        sessionSampleRate: 100
      })
      window.DD_LOGS_INITIALIZED = true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getActiveBannerNotification()
      if (window.DD_LOGS && window.DD_LOGS_INITIALIZED) {
        this.datadogLogsFooter = window.DD_LOGS.createLogger({
          level: 'info',
          handler: 'http',
          context: { logSource: process.env.DATADOG_LOG_SOURCE }
        })
      }
    })
  }
}
</script>

<style>
.text-underline {
  text-decoration: underline;
}
.banner-footer-icon {
  display: inline-block;
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  min-height: 1rem;
  vertical-align: middle;
  line-height: 0;
}
.banner-footer-icon svg {
  width: 100% !important;
  height: 100% !important;
  min-width: 1rem;
  min-height: 1rem;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/BannerFooter.vue